import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './IndonesiaBankThankYou.css';
import { initializeThankYou } from '../thankYouScript.js';

const IndonesiaPaymentThankYou = () => {
  useEffect(() => {
    // Add meta tags to head
    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'Indonesia Bank Account';
    document.head.appendChild(offerMeta);

    try {
      initializeThankYou();
      console.log('Thank you tracking initialized successfully');
    } catch (error) {
      console.error('Error initializing thank you tracking:', error);
    }

    // Cleanup function
    return () => {
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  return (
    <div className="indonesia-bank-ty-container">
      <div className="ty-content">
        <div className="ty-icon">🇮🇩 💳 ✅</div>
        <h1>Payment Confirmed!</h1>
        <p>Thank you for your payment. Your Indonesian bank account opening service has been confirmed.</p>

        <div className="ty-next-steps">
          <h3>What Happens Next?</h3>
          <ul>
            <li>We'll contact you within 24 hours to confirm your details</li>
            <li>We'll connect you with the banker and you can schedule the appointment in Bali</li>
          </ul>
        </div>

        <div className="ty-links">
          <Link to="/relocation-services" className="ty-link">View All Services</Link>
          <Link to="/uae" className="ty-link">UAE Setup Guide</Link>
          <Link to="/consultation" className="ty-link">Book a Consultation</Link>
        </div>
      </div>
    </div>
  );
};

export default IndonesiaPaymentThankYou;